import apiClient from './axios.config';

export const notificationsAPI = {
    getAll: () => apiClient.get('/notifications'),
    markRead: (id) => apiClient.patch(`/notifications/${id}/read`),
    markAllRead: () => apiClient.patch('/notifications/read-all'),
};
